export default __webpack_public_path__ + "static/media/cat_show_into_box.1eee23cc.svg";